(function () {
  function initSupport(root) {
    if (!root || root.dataset.sibrilleSupportReady === 'true') return;
    root.dataset.sibrilleSupportReady = 'true';

    var searchForm = root.querySelector('[data-support-search-form]');
    var searchInput = root.querySelector('[data-support-search-input]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-support-card]'));
    var noResults = root.querySelector('[data-support-no-results]');
    var customSelects = Array.prototype.slice.call(root.querySelectorAll('[data-support-select]'));
    var supportsHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    var selectedCard = null;

    function setActiveCard(card) {
      cards.forEach(function (item) {
        var isActive = item === card && !item.hidden;
        item.classList.toggle('is-active', isActive);
        if (isActive) {
          item.setAttribute('aria-current', 'true');
        } else {
          item.removeAttribute('aria-current');
        }
      });
    }

    function clearActiveCard() {
      setActiveCard(null);
    }

    function filterCards() {
      if (!searchInput || !cards.length) return;

      var value = searchInput.value.trim().toLowerCase();
      var visibleCount = 0;

      cards.forEach(function (card) {
        var haystack = card.getAttribute('data-support-search-text') || '';
        var matched = !value || haystack.indexOf(value) !== -1;
        card.hidden = !matched;
        if (matched) visibleCount += 1;
      });

      if (noResults) {
        noResults.hidden = visibleCount !== 0;
      }

      if (selectedCard && selectedCard.hidden) {
        selectedCard = null;
      }

      if (supportsHover) {
        clearActiveCard();
      } else {
        setActiveCard(selectedCard);
      }
    }

    clearActiveCard();

    cards.forEach(function (card) {
      card.addEventListener('pointerenter', function () {
        setActiveCard(card);
      });

      card.addEventListener('pointerleave', function () {
        if (supportsHover) {
          clearActiveCard();
        }
      });

      card.addEventListener('focus', function () {
        setActiveCard(card);
      });

      card.addEventListener('blur', function () {
        clearActiveCard();
      });

      card.addEventListener('click', function () {
        if (!supportsHover) {
          selectedCard = card;
          setActiveCard(card);
        }
      });
    });

    if (searchInput) {
      searchInput.addEventListener('input', filterCards);
    }

    if (searchForm) {
      searchForm.addEventListener('submit', function (event) {
        event.preventDefault();
        filterCards();

        var grid = root.querySelector('[data-support-card-grid]');
        if (grid) {
          grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    function closeSelect(select, shouldFocus) {
      if (!select) return;

      var button = select.querySelector('[data-support-select-button]');
      var menu = select.querySelector('[data-support-select-menu]');
      select.classList.remove('is-open');

      if (button) {
        button.setAttribute('aria-expanded', 'false');
        if (shouldFocus) button.focus();
      }

      if (menu) {
        menu.hidden = true;
      }
    }

    function closeOtherSelects(activeSelect) {
      customSelects.forEach(function (select) {
        if (select !== activeSelect) closeSelect(select, false);
      });
    }

    customSelects.forEach(function (select) {
      var button = select.querySelector('[data-support-select-button]');
      var menu = select.querySelector('[data-support-select-menu]');
      var label = select.querySelector('[data-support-select-label]');
      var input = select.querySelector('[data-support-select-input]');
      var options = Array.prototype.slice.call(select.querySelectorAll('[data-support-select-option]'));

      if (!button || !menu || !label || !input || !options.length) return;

      function openSelect() {
        closeOtherSelects(select);
        select.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        menu.hidden = false;

        var selected = options.find(function (option) {
          return option.classList.contains('is-selected');
        }) || options[0];

        if (selected) selected.focus();
      }

      function chooseOption(option, shouldFocus) {
        if (!option) return;

        var value = option.getAttribute('data-value') || '';
        input.value = value;
        label.textContent = option.textContent.trim();

        options.forEach(function (item) {
          var isSelected = item === option;
          item.classList.toggle('is-selected', isSelected);
          item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        });

        closeSelect(select, shouldFocus);
      }

      function focusOption(currentIndex, direction) {
        var nextIndex = currentIndex + direction;
        if (nextIndex < 0) nextIndex = options.length - 1;
        if (nextIndex >= options.length) nextIndex = 0;
        options[nextIndex].focus();
      }

      button.addEventListener('click', function () {
        if (select.classList.contains('is-open')) {
          closeSelect(select, false);
        } else {
          openSelect();
        }
      });

      button.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp' || event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openSelect();
        }
      });

      options.forEach(function (option, index) {
        option.addEventListener('click', function () {
          chooseOption(option, true);
        });

        option.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeSelect(select, true);
          }

          if (event.key === 'ArrowDown') {
            event.preventDefault();
            focusOption(index, 1);
          }

          if (event.key === 'ArrowUp') {
            event.preventDefault();
            focusOption(index, -1);
          }

          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            chooseOption(option, true);
          }
        });
      });
    });

    document.addEventListener('click', function (event) {
      customSelects.forEach(function (select) {
        if (!select.contains(event.target)) closeSelect(select, false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      customSelects.forEach(function (select) {
        closeSelect(select, false);
      });
    });

    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;

      var target = root.querySelector(link.getAttribute('href'));
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    var fileInput = root.querySelector('[data-support-file]');
    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var uploadText = root.querySelector('[data-support-upload-main]');
        if (!uploadText) return;

        if (fileInput.files && fileInput.files.length > 0) {
          uploadText.innerHTML = '<strong>' + fileInput.files[0].name + '</strong>';
        }
      });
    }
  }

  function initAll(container) {
    var scope = container || document;
    Array.prototype.slice.call(scope.querySelectorAll('[data-sibrille-support]')).forEach(initSupport);
  }

  initAll(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
